import { UserLocation } from './user-location';

export class LocationList {
    constructor() {
        this.locations = new Array<UserLocation>();
    }

    public locations: Array<UserLocation>;

    public getLastKnownLocation(): UserLocation {
        if (this.locations === null || this.locations.length === 0) {
            return null;
        }
        return this.locations[this.locations.length - 1];
    }

    public toString() {
        let returnVal: string = '';
        for (let i = 0; i < this.locations.length; i++) {
            returnVal += `${this.locations[i].latitude}\t${this.locations[i].longitude}\t${this.locations[i].date.toDateString()}\t${this.locations[i].deviceid}`;
            returnVal += '\r';
        }
        return returnVal;
    }
}
